module.exports = __webpack_public_path__ + "static/media/aftereffects.b1042d6e.svg";